var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import * as LocaleMap from './Language';
export var KG = 1;
export var RU = 2;
export var KZ = 4;
export var US = 5;
export var EU = 6;
export var UZ = 15;
var _resourceNames = (_a = {},
    // [KG]: 'USD',
    // [RU]: 'RUB',
    _a[KZ] = 'KZT',
    _a[US] = 'USD',
    // [EU]: 'EUR',
    _a[UZ] = 'UZS',
    _a);
Object.defineProperty(_resourceNames, 'getCurrencyTag', {
    value: function (id) {
        if (id === void 0) { id = 5; }
        switch (id) {
            case 1:
                return 'KGS';
            default:
                return this[id];
        }
    },
    enumerable: false,
    configurable: false,
    writable: false,
});
export var resourceNames = _resourceNames;
export var resourceAmount = {
    1: 10,
    2: 10,
    4: 100,
    5: 1,
    6: 1,
    15: 1000,
};
export function getResourceAmount(resourceId, countryCode) {
    if (countryCode === 'UZ')
        return 1000;
    if (countryCode === 'KG')
        return 10;
    if (countryCode === 'KZ')
        return 100;
    var amount = resourceAmount[resourceId];
    if (amount)
        return amount;
    return 100;
}
export var resourceNamesDescriptions = (_b = {},
    _b[LocaleMap.RU] = (_c = {
            1: 'USD',
            2: 'Российский рубль',
            4: 'Казахстанский тенге',
            5: 'Американский доллар',
            6: 'Евро'
        },
        _c[UZ] = 'Узбекский сум',
        _c),
    _b[LocaleMap.EN] = (_d = {
            1: 'Kyrgyzstani som',
            2: 'Russian ruble',
            4: 'Kazakhstan tenge',
            5: 'US Dollar',
            6: 'Euro'
        },
        _d[UZ] = 'Uzbekistani soʻm',
        _d),
    _b[LocaleMap.UZ] = (_e = {
            1: 'Qirg\'iz somi',
            2: 'Rossiya rubli',
            4: 'Qozog\'iston tengesi',
            5: 'AQSh dollari',
            6: 'Yevro'
        },
        _e[UZ] = 'O\'zbek so\'mi',
        _e),
    _b[LocaleMap.KK] = (_f = {
            1: 'Қырғыз сомы',
            2: 'Ресей рублі',
            4: 'Қазақстандық теңге',
            5: 'Американдық доллар',
            6: 'Еуро'
        },
        _f[UZ] = 'Өзбек сомасы',
        _f),
    _b);
export var resourceDepositsAndWithdrawals = (_g = {},
    _g[LocaleMap.RU] = (_h = {
            1: 'USD',
            4: 'Банковские карты, Qiwi, Wooppay, Kassa24, Tele2, Altel, Cyberplat'
        },
        _h[UZ] = 'Uzcard и Humo',
        _h),
    _g[LocaleMap.EN] = (_j = {
            1: 'USD',
            4: 'Bank cards, Qiwi, Wooppay, Kassa24, Tele2, Altel, Cyberplat'
        },
        _j[UZ] = 'Uzcard and Humo',
        _j),
    _g[LocaleMap.UZ] = (_k = {
            1: 'USD',
            4: 'Bank kartalari, Qiwi, Wooppay, Kassa24, Tele2, Altel, Cyberplat'
        },
        _k[UZ] = 'Uzcard va Humo',
        _k),
    _g[LocaleMap.KK] = (_l = {
            1: 'USD',
            4: 'Банковские карты, Qiwi, Wooppay, Kassa24, Tele2, Altel, Cyberplat'
        },
        _l[UZ] = 'Uzcard и Humo',
        _l),
    _g);



// WEBPACK FOOTER //
// ./src/constants/accountResourceNames.js